import React from "react";
import { useNavigate } from "react-router-dom"; // Import useNavigate hook for routing
import "./topCategories.css";
import CorporateLaw from "./assets/corporateLaw.png";
import CriminalLaw from "./assets/criminalLaw.png";
import EmploymentLaw from "./assets/employmentLaw.png";
import FamilyLaw from "./assets/familyLaw.png";
import GeneralLaw from "./assets/generalLaw.png";
import ImmigrationLaw from "./assets/immigrationLaw.png";

const categories = [
  { name: "General", icon: GeneralLaw, value: "general-law", color: "#8B5CF6" },
  { name: "Immigration", icon: ImmigrationLaw, value: "immigration-law", color: "#14B8A6" },
  { name: "Family", icon: FamilyLaw, value: "family-law", color: "#EC4899" },
  { name: "Criminal", icon: CriminalLaw, value: "criminal-law", color: "#EF4444" },
  { name: "Employment", icon: EmploymentLaw, value: "labor-law", color: "#F59E0B" },
  { name: "Corporate", icon: CorporateLaw, value: "corporate-law", color: "#3B82F6" },
];

const TopCategories = () => {
  const navigate = useNavigate(); // Hook to handle navigation

  // Function to handle category click and navigate to search results
  const handleCategoryClick = (categoryName) => {
    navigate(
      `/search-results?practice_area=${categoryName}&latitude=41.8781&longitude=-87.6298&radius=40000&location=Chicago,IL,USA`
    );
  };

  // Function to handle "Show All" click
  const handleShowAllClick = () => {
    // Navigate to search results with Chicago as the default location coordinates
    navigate(
      `/search-results?latitude=41.8781&longitude=-87.6298&radius=40000&location=Chicago,IL,USA`
    ); // Chicago coordinates
  };

  return (
    <div className="category-container">
      <div className="top-categories-header">
        <h2 className="top-categories-title">Explore Popular Legal Categories</h2>
        <p className="top-categories-show-all" onClick={handleShowAllClick}>
          Show all →
        </p>
      </div>
      <div className="category-grid">
        {categories.map((category, index) => (
          <div
            key={index}
            className="category-card"
            onClick={() => handleCategoryClick(category.value)}
          >
            <div className="category-icon-wrapper">
              <img
                src={category.icon}
                alt={category.name}
                className="category-icon"
              />
            </div>
            <p className="home-category-title">{category.name}</p>
          </div>
        ))}
      </div>
    </div>
  );
};

export default TopCategories;
